import React from "react";
import moment from "moment";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Label,
  FormGroup,
} from "reactstrap";
import {
  Upload,
  Icon,
  notification,
  message,
  Button,
  DatePicker,
  Select,
  Input,
} from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import {
  getClientList,
  createComercialRecord,
  createPcpRecord,
  handleChangeSwift,
  customUploadSwift,
} from "services";
import firebase from "../../../Firebase.js";
import "./EditComercialRegister.scss"; // Reuse same theme

const { Option } = Select;

class NewComercialRegister extends React.Component {
  constructor() {
    super();
    this.storageRef = firebase.storage();
    this.state = {
      loading: false,
      fechaIngreso: new Date(),
      cliente: "",
      prof: "",
      fechaEntrega: new Date(),
      imgProf: null,
      imgProfsp: null,
      clientsList: [],
      selectedOption: "",
      isActive: false,
      proforma: [],
      selectedFile: null,
      selectedFileList: [],
      pdfUrl: "",
      filelistVenta: null,
      filelistProd: null,
      swifts: [
        { name: 'SWIFT 1', url: '', fileList: [] }
      ],
    };
  }

  handleClientList = async () => {
    this.setState({ loading: true });
    try {
      const data = await getClientList();
      this.setState({ clientsList: data });
    } catch (error) {
      console.error("Error loading clients:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    this.handleClientList();

    firebase
      .firestore()
      .collection("comercial")
      .orderBy("order", "asc")
      .get()
      .then((querySnap) => {
        const prof = [];
        const swf30 = [];
        const swf70 = [];
        querySnap.forEach((doc) => {
          if (doc.data().prof) {
            prof.push(doc.data().prof);
          }
          if (doc.data().sw30) {
            swf30.push(doc.data().sw30);
          }
          if (doc.data().sw70) {
            swf70.push(doc.data().sw70);
          }
        });
        this.setState({
          proforma: prof,
          swift30file: swf30,
          swift70file: swf70,
        });
      });
  }

  handleChangeIngreso = (date) => {
    this.setState({ fechaIngreso: date });
  };

  handleChangeEntrega = (date) => {
    this.setState({ fechaEntrega: date });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  selectHandleChange = (selectedOption) => {
    this.setState({ selectedOption });
  };

  addSwift = () => {
    const { swifts } = this.state;
    this.setState({
      swifts: [
        ...swifts,
        { name: `SWIFT ${swifts.length + 1}`, url: "", fileList: [] },
      ],
    });
  };

  removeSwift = (index) => {
    const { swifts } = this.state;
    if (swifts.length > 1) {
      const newSwifts = swifts.filter((_, i) => i !== index);
      // Preserve existing filenames
      this.setState({ swifts: newSwifts });
    }
  };

  handleSwiftChange = (index, info) => {
    const { swifts } = this.state;
    const newSwifts = [...swifts];
    
    // Ant Design Upload state management
    let fileList = [...info.fileList];
    if (fileList.length > 1) {
      fileList.splice(0, 1); // Keep only the latest
    }
    
    fileList = fileList.map(file => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });

    newSwifts[index].fileList = fileList;
    if (fileList.length > 0 && fileList[0].status === 'done') {
      newSwifts[index].url = fileList[0].url || fileList[0].xhr?.url;
      // Set name to original filename from the file object
      newSwifts[index].name = fileList[0].name;
    } else if (fileList.length === 0) {
      newSwifts[index].url = "";
    }

    this.setState({ swifts: newSwifts });

    if (info.file.status === "uploading") {
      this.setState({ loading: true });
    } else {
      this.setState({ loading: false });
    }
  };

  onSubmit = async (e) => {
    if (e) e.preventDefault();
    
    const {
      fechaIngreso,
      fechaEntrega,
      prof,
      selectedOption,
      swifts,
    } = this.state;

    this.setState({ isActive: true });

    const fechaEntregaFormat = moment(fechaEntrega).format("DD/MM/YYYY");
    const fechaIngresoFormat = moment(fechaIngreso).format("DD/MM/YYYY");

    message.loading({ content: "Registrando...", key: 'registering_comercial' });

    try {
      const profVentaUrl = this.state.filelistVenta[0].xhr.url;
      const profProdUrl = this.state.filelistProd[0].xhr.url;
      
      // Map swifts for database
      const dbSwifts = swifts.map(s => ({
        name: s.name,
        url: s.url
      }));

      // Legacy fields mapping
      const sw30furl = swifts[0]?.url || "";
      const sw70furl = swifts[1]?.url || "";
      const swift30 = sw30furl ? "30" : "";
      const swift70 = sw70furl ? "70" : "";

      await createComercialRecord({
        a: [profVentaUrl],
        b: [],
        cFechaEntrega: fechaEntregaFormat,
        cFechaIngreso: fechaIngresoFormat,
        cliente: selectedOption,
        estado: "",
        f: [],
        fichaTecnica: "",
        op: "",
        otros: [],
        prof: prof,
        profsp: [profProdUrl],
        status: "Nuevo",
        isEditable: true,
        sw30Files: [sw30furl],
        sw70Files: [sw70furl],
        sw30: swift30,
        sw70: swift70,
        swifts: dbSwifts, // New field
      });

      await createPcpRecord({
        cFechaEntrega: fechaEntregaFormat,
        cliente: selectedOption,
        op: "",
        cFechaIngreso: fechaIngresoFormat,
        prof: prof,
        a: [profProdUrl],
        fichaTecnica: "",
        estado: ["Nuevo", prof],
        b: [],
        otros: [],
        isEditable: true,
      });

      message.destroy();
      notification.success({
        message: "Registro Exitoso",
        description: "El registro comercial ha sido creado correctamente.",
        top: 80,
      });
      this.props.history.push("/comercial/Procesos");
    } catch (error) {
      message.destroy();
      console.error(error);
      notification.error({
        message: "Error de Registro",
        description: `Se encontró un error: ${error.message}`,
        top: 80,
      });
      this.setState({ isActive: false });
    }
  };

  render() {
    const { prof, selectedOption, fechaEntrega, loading, isActive } = this.state;
    
    // Check if critical files are uploaded
    const hasVenta = this.state.filelistVenta && this.state.filelistVenta.length > 0 && this.state.filelistVenta[0].status === "done";
    const hasProd = this.state.filelistProd && this.state.filelistProd.length > 0 && this.state.filelistProd[0].status === "done";
    
    const isUploading = 
      (this.state.filelistVenta && this.state.filelistVenta.some(f => f.status === 'uploading')) ||
      (this.state.filelistProd && this.state.filelistProd.some(f => f.status === 'uploading')) ||
      (this.state.filelistsw30 && this.state.filelistsw30.some(f => f.status === 'uploading')) ||
      (this.state.filelistsw70 && this.state.filelistsw70.some(f => f.status === 'uploading'));

    const isInvalid = !selectedOption || !prof || !fechaEntrega || !hasVenta || !hasProd || isUploading;

    const uploadButton = (
      <Button icon={<Icon type={loading ? "loading" : "plus"} />} className="ant-btn-upload">
        Subir Archivo
      </Button>
    );

    const handleState = (fileListSw, secondaryFileListSw, info) => {
      const infofileList = [...info.fileList];
      if (info.fileList.length > 1) {
        infofileList.splice(0, 1);
      }
      const fileResponse = infofileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });

      this.setState({
        [fileListSw]: info.fileList,
        [secondaryFileListSw]: fileResponse,
      });
    };

    const handleLoadingState = (l) => {
      this.setState({ loading: l });
    };

    const handleUploadfile = (file, nameState) => {
      this.setState({
        [nameState]: file.name.split(".")[0],
      });
    };

    return (
      <div className="content edit-comercial-register">
        <Row>
          <Col md={10} lg={8} className="ml-auto mr-auto">
            <Card className="card-user">
              <CardHeader>
                <CardTitle>REGISTRO COMERCIAL</CardTitle>
              </CardHeader>
              <CardBody style={{ padding: '30px' }}>
                <form onSubmit={this.onSubmit}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="form-group-label" for="cliente">CLIENTE</Label>
                        <Select
                          showSearch
                          style={{ width: '100%' }}
                          placeholder="Seleccionar Cliente"
                          onChange={this.selectHandleChange}
                          value={selectedOption || undefined}
                          filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {this.state.clientsList.map((item, idx) => (
                            <Option key={idx} value={item.client.name}>
                              {item.client.name}
                            </Option>
                          ))}
                        </Select>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="form-group-label" for="prof">FACTURA PROFORMA</Label>
                        <Input
                          name="prof"
                          value={prof}
                          placeholder="Nombre FP (automático)"
                          onChange={this.onChange}
                          autoComplete="off"
                          required
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="form-group-label" for="fechaEntrega">FECHA DESPACHO</Label>
                        <DatePicker
                          style={{ width: '100%', height: '42px' }}
                          value={fechaEntrega ? moment(fechaEntrega) : null}
                          onChange={this.handleChangeEntrega}
                          format={"DD/MM/YYYY"}
                          locale={locale}
                          placeholder="Seleccionar fecha"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <div className="upload-grid mt-4">
                    <Row>
                      <Col md={6}>
                        <div className="upload-section">
                          <Label className="upload-label">
                            <Icon type="file-text" style={{ marginRight: '8px', color: '#1890ff' }} />
                            FACTURA PROFORMA CON PRECIO*
                          </Label>
                          <Upload
                            onRemove={() => this.setState({ filelistVenta: null, prof: "" })}
                            accept={".pdf"}
                            multiple={false}
                            onChange={(info) => handleChangeSwift(info, "filelistVenta", "fileListVenta", handleState, handleLoadingState)}
                            customRequest={({ onError, onSuccess, file }) =>
                              customUploadSwift({
                                onError, onSuccess, file,
                                folder: "profVenta",
                                stateList: this.state.proforma,
                                nameState: "prof",
                                handleUploadfile,
                                notification
                              })
                            }
                            fileList={this.state.fileListVenta}
                          >
                            {uploadButton}
                          </Upload>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="upload-section">
                          <Label className="upload-label">
                            <Icon type="file-done" style={{ marginRight: '8px', color: '#52c41a' }} />
                            FACTURA PROFORMA SIN PRECIO*
                          </Label>
                          <Upload
                            onRemove={() => this.setState({ filelistProd: null, prof: "" })}
                            accept={".pdf"}
                            multiple={false}
                            onChange={(info) => handleChangeSwift(info, "filelistProd", "fileListProd", handleState, handleLoadingState)}
                            customRequest={({ onError, onSuccess, file }) =>
                              customUploadSwift({
                                onError, onSuccess, file,
                                folder: "profProd",
                                stateList: this.state.proforma,
                                nameState: "prof",
                                handleUploadfile,
                                notification
                              })
                            }
                            fileList={this.state.fileListProd}
                          >
                            {uploadButton}
                          </Upload>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      {this.state.swifts.map((swift, index) => (
                        <Col md={6} key={index}>
                          <div className="upload-section">
                            <Label className="upload-label">
                              <Icon type="dollar" style={{ marginRight: '8px', color: '#faad14' }} />
                              {`SWIFT DE TRANSFERENCIA ${index + 1}`}
                            </Label>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                              <div style={{ flex: 1 }}>
                                <Upload
                                  onRemove={() => {
                                    const newSwifts = [...this.state.swifts];
                                    newSwifts[index].url = "";
                                    newSwifts[index].fileList = [];
                                    this.setState({ swifts: newSwifts });
                                  }}
                                  accept={".pdf, .jpeg, .jpg, .png, .img, tiff, .bmp"}
                                  multiple={false}
                                  onChange={(info) => this.handleSwiftChange(index, info)}
                                  customRequest={({ onError, onSuccess, file }) =>
                                    customUploadSwift({
                                      onError, onSuccess, file,
                                      folder: "swComercial",
                                      stateList: [],
                                      nameState: `swift_${index}`,
                                      notification
                                    })
                                  }
                                  fileList={swift.fileList}
                                >
                                  {uploadButton}
                                </Upload>
                              </div>
                              {this.state.swifts.length > 1 && (
                                <Button 
                                  type="danger" 
                                  shape="circle"
                                  icon="delete" 
                                  size="small"
                                  onClick={() => this.removeSwift(index)}
                                  style={{ marginTop: '5px' }}
                                />
                              )}
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                    <div className="mt-2 mb-4">
                      <Button 
                        type="dashed" 
                        onClick={this.addSwift} 
                        icon="plus" 
                        style={{ width: '100%', height: '42px', borderRadius: '8px' }}
                      >
                        Agregar Pago / SWIFT
                      </Button>
                    </div>
                  </div>

                  <div className="text-center mt-5">
                    <Button
                      type="primary"
                      className="btn-submit"
                      onClick={this.onSubmit}
                      loading={isActive}
                      disabled={isActive || isInvalid}
                    >
                      REGISTRAR COMERCIAL
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default NewComercialRegister;
